import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Wrapper, StyledNav, NavLink } from "./NavigationBar.styled";
import "utils/fontAwesome";

const NavigationBar: React.FC = () => {
  const location = useLocation();
  const [activeNav, setActiveNav] = useState<string>(() => {
    const pathname = location.pathname.split('/')[1];
    if (pathname === 'home') return 'home';
    return pathname;
  });

  useEffect(() => {
    localStorage.getItem("accessToken");
  }, []);

  useEffect(() => {
    const pathname = location.pathname.split('/')[1];
    if (pathname === 'home') {
      setActiveNav('home');
    } else if (pathname === 'account-management' || pathname === 'reservations' || pathname === 'reviews') {
      setActiveNav('mypage');
    } else {
      setActiveNav(pathname);
    }
  }, [location.pathname]);

  useEffect(() => {
    localStorage.setItem("activeNav", activeNav);
  }, [activeNav]);

  const handleClick = (navItem: string) => {
    setActiveNav(navItem);
  };

  return (
    <Wrapper>
      <StyledNav>
        <NavLink to="/home" onClick={() => handleClick('home')}>
          <div>
            <FontAwesomeIcon
              icon="house"
              style={{ fontSize: '1.5em' }}
              className={activeNav === 'home' ? "active" : "nav-item"}
            />
            <p className={activeNav === 'home' ? "active" : "nav-item"}>홈</p>
          </div>
        </NavLink>
        <NavLink to="/reservation" onClick={() => handleClick('reservation')}>
          <div>
            <FontAwesomeIcon
              icon="calendar-check"
              style={{ fontSize: '1.5em' }}
              className={activeNav === 'reservation' ? "active" : "nav-item"}
            />
            <p className={activeNav === 'reservation' ? "active" : "nav-item"}>시설</p>
          </div>
        </NavLink>
        <NavLink to="/map" onClick={() => handleClick('map')}>
          <div>
            <FontAwesomeIcon
              icon="map-location-dot"
              style={{ fontSize: '1.5em' }}
              className={activeNav === 'map' ? "active" : "nav-item"}
            />
            <p className={activeNav === 'map' ? "active" : "nav-item"}>지도</p>
          </div>
        </NavLink>
        <NavLink to="/mypage" onClick={() => handleClick('mypage')}>
          <div>
            <FontAwesomeIcon
              icon="circle-user"
              style={{ fontSize: '1.5em' }}
              className={activeNav === 'mypage' ? "active" : "nav-item"}
            />
            <p className={activeNav === 'mypage' ? "active" : "nav-item"}>마이페이지</p>
          </div>
        </NavLink>
      </StyledNav>
    </Wrapper>
  );
};

export default NavigationBar;
